export default {
  campaigns: ({ campaigns }) =>
    campaigns.filter(({ template }) => template === 'campaign'),
  brands: ({ campaigns }) =>
    campaigns.filter(({ template }) => template === 'brand'),
  formInput: ({ formInput }) => formInput,
}
